import {getMethod} from '~/api'

async function get() {
    return await getMethod('/api/report-issue-info')
}

export {get}
